module.exports = __webpack_public_path__ + "static/img/error_icon.f265021.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/error_icon.png
// module id = voJh
// module chunks = 21